<template>
  <div class="navbar">
    <logo v-if="settingsStore.sidebarLogo" class="mixed-brand" :collapse="appStore.device === 'mobile'" />
    <top-nav
      id="topmenu-container"
      class="topmenu-container"
    />

    <div class="right-menu">
      <!-- <template v-if="appStore.device !== 'mobile'">
        <header-search id="header-search" class="right-menu-item" />

        <el-tooltip :content="$tt('源码地址')" effect="dark" placement="bottom">
          <ruo-yi-git id="ruoyi-git" class="right-menu-item hover-effect" />
        </el-tooltip>

        <el-tooltip :content="$tt('文档地址')" effect="dark" placement="bottom">
          <ruo-yi-doc id="ruoyi-doc" class="right-menu-item hover-effect" />
        </el-tooltip>

        <screenfull id="screenfull" class="right-menu-item hover-effect" />

        <el-tooltip :content="$tt('主题模式')" effect="dark" placement="bottom">
          <div class="right-menu-item hover-effect theme-switch-wrapper" @click="toggleTheme">
            <svg-icon v-if="settingsStore.isDark" icon-class="sunny" />
            <svg-icon v-if="!settingsStore.isDark" icon-class="moon" />
          </div>
        </el-tooltip>

        <el-tooltip :content="$tt('布局大小')" effect="dark" placement="bottom">
          <size-select id="size-select" class="right-menu-item hover-effect" />
        </el-tooltip>
      </template> -->
      <language-switch class="right-menu-item hover-effect language-menu" />
      <div class="avatar-container">
        <el-dropdown
          @command="handleCommand"
          class="right-menu-item hover-effect"
          trigger="click"
          placement="bottom-end"
          popper-class="account-center-popper"
          :show-arrow="false"
          :popper-options="{ modifiers: [{ name: 'offset', options: { offset: [0, 12] } }] }"
        >
          <div class="avatar-wrapper">
            <!-- <img :src="userStore.avatar" class="user-avatar" /> -->
            <img
              :src="userStore.avatar"
              style="object-fit: cover"
              class="user-avatar"
            />
            <el-icon><caret-bottom /></el-icon>
          </div>
          <template #dropdown>
            <div class="account-panel">
              <div class="account-panel-header">
                <img
                  :src="userStore.avatar"
                  class="account-panel-avatar" alt=""
                />
                <span class="account-panel-name" :title="userStore.name">{{ userStore.name }}</span>
                <el-tooltip :content="settingsStore.isDark ? $tt('切换浅色主题') : $tt('切换深色主题')" placement="top">
                  <button type="button" class="account-theme-toggle"
                    :aria-label="settingsStore.isDark ? $tt('切换浅色主题') : $tt('切换深色主题')"
                    :aria-pressed="settingsStore.isDark" @click.stop="toggleTheme">
                    <svg-icon :icon-class="settingsStore.isDark ? 'sunny' : 'moon'" />
                  </button>
                </el-tooltip>
              </div>
              <el-dropdown-menu>
                <el-dropdown-item command="accountSettings" :icon="Setting">
                  <span>{{ $tt('账号设置') }}</span>
                </el-dropdown-item>
                <el-dropdown-item command="logout" class="account-logout-item" :icon="SwitchButton">
                  <span>{{ t('layout.logout') }}</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </div>
          </template>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ElMessageBox } from "element-plus";
import { SwitchButton, Setting } from "@element-plus/icons-vue";
import Logo from "./Sidebar/Logo.vue";
import TopNav from "@/components/TopNav";
import Screenfull from "@/components/Screenfull";
import SizeSelect from "@/components/SizeSelect";
import HeaderSearch from "@/components/HeaderSearch";
import RuoYiGit from "@/components/RuoYi/Git";
import RuoYiDoc from "@/components/RuoYi/Doc";
import useAppStore from "@/store/modules/app";
import useUserStore from "@/store/modules/user";
import useSettingsStore from "@/store/modules/settings";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import LanguageSwitch from "@/components/LanguageSwitch/index.vue";

const router = useRouter();
const { t } = useI18n();
const appStore = useAppStore();
const userStore = useUserStore();
const settingsStore = useSettingsStore();


function handleCommand(command) {
  switch (command) {
    case "accountSettings":
      router.push("/user/profile");
      break;
    case "setLayout":
      setLayout();
      break;
    case "logout":
      logout();
      break;
    default:
      break;
  }
}

function logout() {
  ElMessageBox.confirm(t("layout.logoutConfirm"), t("modal.prompt"), {
    confirmButtonText: t("common.confirm"),
    cancelButtonText: t("common.cancel"),
    type: "warning",
  })
    .then(() => {
      userStore.logOut().then(() => {
        location.href = "/login";
      });
    })
    .catch(() => {});
}

const emits = defineEmits(["setLayout"]);
function setLayout() {
  emits("setLayout");
}

function toggleTheme() {
  settingsStore.toggleTheme();
}
</script>

<style lang="scss" scoped>
.account-panel {
  box-sizing: border-box;
  width: 240px;
  max-width: calc(100vw - 32px);
  padding: 12px;
  color: var(--sb-text);
}
.account-panel-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0 12px;
  margin-bottom: 8px;
  border-bottom: 1px solid var(--sb-divider);
}
.account-panel-avatar {
  flex: 0 0 32px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
}
.account-panel-name {
  flex: 1;
  min-width: 0;
  font-size: 14px;
  line-height: 22px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.account-theme-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 32px;
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 10px;
  background: var(--sb-bg-subtle);
  color: var(--sb-text-secondary);
  font-size: 20px;
  cursor: pointer;
  &:hover { background: var(--sb-bg-hover); color: var(--sb-color-primary-text); }
  &:focus-visible { outline: 2px solid var(--sb-color-primary-text); outline-offset: 2px; }
}

.account-panel :deep(.el-dropdown-menu) { padding: 0; background: transparent; }
.account-panel :deep(.el-dropdown-menu__item) {
  min-height: 40px;
  padding: 8px;
  box-sizing: border-box;
  border-radius: 6px;
  font-size: 14px;
  line-height: 22px;
  color: var(--sb-text);
}
.account-panel :deep(.el-dropdown-menu__item .el-icon) {
  width: 20px;
  height: 20px;
  font-size: 20px;
  margin-right: 8px;
  color: var(--sb-text-muted);
}
.account-panel :deep(.el-dropdown-menu__item:not(.is-disabled):hover),
.account-panel :deep(.el-dropdown-menu__item:not(.is-disabled):focus) {
  background: var(--sb-bg-hover);
  color: var(--sb-color-primary-text);
}
.account-panel :deep(.el-dropdown-menu__item:not(.is-disabled):hover .el-icon),
.account-panel :deep(.el-dropdown-menu__item:not(.is-disabled):focus .el-icon) { color: inherit; }
.account-panel :deep(.account-logout-item) {
  margin-top: 8px;
  border-top: 1px solid var(--sb-divider);
  border-radius: 0 0 6px 6px;
  padding-top: 12px;
  min-height: 44px;
}

.navbar {
  height: 64px;
  overflow: hidden;
  position: relative;
  background: var(--navbar-bg);
  box-shadow: none;
  border-bottom: 1px solid var(--sb-divider);

  .hamburger-container {
    line-height: 64px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .topmenu-container {
    position: absolute;
    left: 50px;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 64px;
    display: flex;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: var(--navbar-text);
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }

      &.theme-switch-wrapper {
        display: flex;
        align-items: center;

        svg {
          transition: transform 0.3s;

          &:hover {
            transform: scale(1.15);
          }
        }
      }
    }

    .avatar-container {
      margin-right: 40px;

      .avatar-wrapper {
        margin-top: 12px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 50%;
        }

        i {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }

    .language-menu {
      display: flex;
      align-items: center;
      font-size: 14px;
    }
  }
}
</style>

<style lang="scss">
.el-popper.account-center-popper {
  padding: 0;
  border: 1px solid var(--sb-divider);
  border-radius: 12px;
  background: var(--sb-bg-overlay);
  box-shadow: var(--sb-shadow);
}
</style>
